import React from 'react';

/** Container — max-width + responsive horizontal padding. */
export function Container({ variant = 'default', className = '', children, as: Tag = 'div', ...rest }) {
  const widths = {
    narrow: 'max-w-[920px]',
    default: 'max-w-[1440px]',
    wide: 'max-w-[1440px]',
    full: 'max-w-full',
  };
  return (
    <Tag className={`${widths[variant] || widths.default} mx-auto px-5 lg:px-10 ${className}`} {...rest}>
      {children}
    </Tag>
  );
}
